import DashboardRollout from './DashboardRollout'
import { selectStats } from '../../reducers/stats'
import { useSelector } from 'react-redux'
import DashboardRisk from './DashboardRisk'
import { selectUser } from '../../reducers/users'
import { inPov } from '../../utils/session.ts'
import { HEADER_HEIGHT_WITH_TRIAL, HEADER_HEIGHT_WITHOUT_TRIAL } from '../../strings/consts.ts'

function DashboardWrapper() {
  const { tabToShow } = useSelector(selectStats)
  const { session } = useSelector(selectUser)

  return (
    <div
      className="absolute top-18 left-52 rounded-tl-lg border-mainBorder border-t border-l w-[calc(100%_-_208px)] bg-contentBackground"
      style={{
        height: inPov(session)
          ? `calc(100% - ${HEADER_HEIGHT_WITH_TRIAL})`
          : `calc(100% - ${HEADER_HEIGHT_WITHOUT_TRIAL})`,
      }}
    >
      <div className="grid grid-cols-4 h-full overflow-y-auto">
        <div className="col-span-4 p-4">
          {tabToShow === 'risk' ? (
            <>
              <DashboardRisk />
            </>
          ) : (
            <>
              <DashboardRollout />
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default DashboardWrapper
